import { API_BASE_URL } from './api'
import type { ApiResponse, CheckoutSession } from '@/types'

// PUBLIC Stripe-redirect landing read. Bare `fetch`, NOT `apiClient`, on
// purpose: visitor may not be logged in, and we must avoid apiClient's 401
// interceptor (refresh -> forceLogout -> redirect to /login) on a payment
// confirmation. API_BASE_URL already includes the /api/v1 segment.
export const checkoutApi = {
  getSession: async (
    sessionId: string
  ): Promise<ApiResponse<CheckoutSession>> => {
    const res = await fetch(
      `${API_BASE_URL}/checkout/session/${encodeURIComponent(sessionId)}`,
      { headers: { Accept: 'application/json' } }
    )
    if (!res.ok) {
      throw new Error(`Checkout session lookup failed (${res.status})`)
    }
    return res.json()
  },
}

export default checkoutApi
